import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import { ACCOUNT_TYPES } from '../common/constants';
import Stack from '@mui/material/Stack';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import PersonIcon from '@mui/icons-material/Person';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';

const Header = (props) => {
  const { loginUser } = props;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const styles = {
    popover: {
      marginTop: '10px',
    },
    logoutButton: {
      width: '128px',
      height: '56px',
      textDecoration: 'underline',
      fontSize: '16px',
      lineHeight: '150%',
    },
  };

  const handlePopoverClose = () => {
    setOpen(false);
  };

  const handlePopoverOpen = (e) => {
    setAnchorEl(e.currentTarget);
    setOpen(true);
  };

  const handleSignOut = async () => {
    try {
      await axios.delete('/v1/auth/web/logout');
      navigate('/login', { replace: true });
    } catch (err) { }
  };

  return (
    <Stack bgcolor='white' padding='16px' >
      <Container sx={{ display: 'flex' }}>
        <Typography variant='caption12' marginRight='18px'>
          【指導用】運転規制通告トレーニング
        </Typography>
        <Typography variant='caption12'>
          {loginUser.organizationName}
        </Typography>
        <ClickAwayListener onClickAway={handlePopoverClose}>
          <Button onClick={handlePopoverOpen} sx={{ padding: '0', marginLeft: 'auto' }}>
            <PersonIcon sx={{ fontSize: '16px', color: 'primary.main' }} />
            <Typography variant="caption12bold" color='primary.main' marginRight='4px' >
              {loginUser.name}
            </Typography>
            <Typography variant="caption12bold" color='primary.main' marginRight='8px' >
              {ACCOUNT_TYPES.TRAINER.label}
            </Typography>
          </Button>
        </ClickAwayListener>
        <Typography variant='caption12bold' color='darkgray' fontWeight='800'>
          ログイン中
        </Typography>
        <Popover
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          sx={styles.popover}
        >
          <Button
            role="link"
            onClick={handleSignOut}
            sx={styles.logoutButton}
          >
            ログアウト
          </Button>
        </Popover>
      </Container>
    </Stack>
  );
};

export default Header;

Header.propTypes = {
  loginUser: PropTypes.object,
};
